module.exports = __webpack_public_path__ + "img/danger.13eefc9e.svg";